// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarDiasUteisPeriodicidadeNumerador,
  getDiasUteisPeriodicidadeNumeradorSelecionado,
} from "../../../../state";
import { VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_NUMERADOR } from "../../../../model";

type Prop = {
  diasUteisPeriodicidadeNumerador: number,
  editarDiasUteisPeriodicidadeNumerador: ActionCreator,
};

function SelecaoDiasUteisPeriodicidadeNumerador({
  diasUteisPeriodicidadeNumerador,
  editarDiasUteisPeriodicidadeNumerador,
}: Prop) {
  function handleDiasUteisPeriodicidadeNumeradorEditado(
    diasUteisPeriodicidadeNumerador
  ) {
    editarDiasUteisPeriodicidadeNumerador(diasUteisPeriodicidadeNumerador);
  }

  function onBlur() {
    if (
      diasUteisPeriodicidadeNumerador !== 0 &&
      !diasUteisPeriodicidadeNumerador
    ) {
      editarDiasUteisPeriodicidadeNumerador(
        VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_NUMERADOR
      );
    }
  }

  return (
    <div>
      <Translate>Comum.DiasUteis</Translate>
      <NumberField
        allowNegative={false}
        onlyInteger={true}
        max={1000}
        min={1}
        onChangeValue={handleDiasUteisPeriodicidadeNumeradorEditado}
        value={diasUteisPeriodicidadeNumerador}
        thousandSeparator={""}
        onBlur={onBlur}
        className="ConfiguracaoMedida__input"
      />
    </div>
  );
}

export default connect(
  state => ({
    diasUteisPeriodicidadeNumerador: getDiasUteisPeriodicidadeNumeradorSelecionado(
      state
    ),
  }),
  { editarDiasUteisPeriodicidadeNumerador }
)(SelecaoDiasUteisPeriodicidadeNumerador);
